// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HceLoadingTask } from './types';

@Component({
  selector: 'app-hce-loading-overlay',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './hce-loading-overlay.component.html',
  styleUrls: ['./hce-loading-overlay.component.css'],
})
export class HceLoadingOverlayComponent {
  private _title = '';
  private _tasks: HceLoadingTask[] = [];

  @Input()
  set title(value: string | undefined | null) {
    this._title = (value ?? '');
  }
  get title(): string {
    return this._title;
  }

  @Input()
  set tasks(value: HceLoadingTask[] | undefined | null) {
    this._tasks = (value ?? []);
  }
  get tasks(): HceLoadingTask[] {
    return this._tasks;
  }
}